import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    totalTime: translate({ id: 'scheduler.popOver.totalTime.title' }),
    unlimited: translate({ id: 'scheduler.popOver.totalTime.unlimited' }),

    workingTime: (value: string, total: string, saturation: number) =>
      translate({
        id: 'scheduler.popOver.totalTime.workingTime',
        values: { value, total, saturation },
      }),

    drivingTime: (value: string, total: string, saturation: number) =>
      translate({
        id: 'scheduler.popOver.totalTime.title.drivingTime',
        values: { value, total, saturation },
      }),
  }))

  return api
}
